import Comments, { Delete } from "./Comments";
export default Comments;
export { Delete };
